class OverviewContentWithTabs extends HTMLElement {
	constructor( )
	{
		super();
	}

	connectedCallback()
	{
		// Scope queries to this element instance.
		this.tabs = this.querySelectorAll( '[class^="ocwt-tab"]' );
		this.highlights = this.querySelectorAll( '[class^="ocwt-hl"]' );
		this.tabPadding = this.dataset.tabPadding;
		this.setupTabs(  );
		this.setupHighlights( );
		this.initialiseOpenHeights( );
	}

	setBodyHeight ( tabEl, open )
	{
		const body = tabEl.querySelector( '[class^="ocwt-tab-bd"]' );
		if ( !body ) return;
		if ( open )
		{
			body.style.maxHeight = "none";
			const h = body.scrollHeight + this.tabPadding * 2; // include vertical padding
			body.style.maxHeight = "0px";
			void body.offsetHeight; // force reflow
			body.style.maxHeight = h + "px";
		}
		else
		{
			body.style.maxHeight = "0px";
		}
	}

	initialiseOpenHeights( )
	{
		this.tabs.forEach( ( tab ) =>
		{
			const isActive = tab.classList.contains( "active" );
			this.setBodyHeight( tab, isActive );
		});
	}

	setupTabs( )
	{
		this.tabs.forEach( ( tab ) =>
		{
			const header = tab.querySelector( '[class^="ocwt-tab-hd"]' );
			if ( !header ) return;
			header.addEventListener( "click", ( ) =>
			{
				const isActive = tab.classList.contains( "active" );
				tab.classList.toggle( "active" );
				header.setAttribute( "aria-expanded", ( !isActive ).toString( ) );
				this.setBodyHeight( tab, !isActive );
			});
		});

		let resizeTO;
		window.addEventListener("resize", () => {
		clearTimeout(resizeTO);
		resizeTO = setTimeout(() => this.initialiseOpenHeights(), 150);
		});
	}

	setupHighlights( )
	{
		this.highlights.forEach( ( hl ) =>
		{
			const button = hl.querySelector( '[class^="ocwt-hl-btn"]' );
			const popup = hl.querySelector( '[class^="ocwt-pop"]' );
			if ( !button || !popup ) return;
			const closeButton = popup.querySelector( '[class^="ocwt-pop-close"]' );

			button.addEventListener( "click", ( ) =>
			{
				this.querySelectorAll( '[class^="ocwt-pop"]' ).forEach( ( p ) =>
				{
					if ( p !== popup )
					{
						p.classList.remove( "active" );
						const btn = p.previousElementSibling;
						if ( btn ) btn.setAttribute( "aria-expanded", "false" );
					}
				});
				const isActive = popup.classList.contains( "active" );
				popup.classList.toggle( "active" );
				button.setAttribute( "aria-expanded", ( !isActive ).toString( ) );
			});

			if ( closeButton )
			{
				closeButton.addEventListener( "click", ( ) =>
				{
					popup.classList.remove( "active" );
					button.setAttribute( "aria-expanded", "false" );
				});
			}
		});

		document.addEventListener( "click", ( event ) =>
		{
			if ( !event.target.closest( '[class^="ocwt-pop"]' ) && !event.target.closest( '[class^="ocwt-hl-btn"]' ) )
			{
				this.querySelectorAll( '[class^="ocwt-pop"]' ).forEach( ( popup ) =>
				{
					popup.classList.remove( "active" );
					const btn = popup.previousElementSibling;
					if ( btn ) btn.setAttribute( "aria-expanded", "false" );
				});
			}
		});
	}
}

if ( !customElements.get( "overview-content-with-tabs" ) )
{
	customElements.define( "overview-content-with-tabs", OverviewContentWithTabs );
}
